<template>
  <b-container fluid class="text-dark">
        <b-row>
          <b-col xs="12" sm="12" md="12" class="text-right" style="">
              <b-button variant="primary" @click="pdfExport">
                  <i style="font-size: 18px; margin: 0; padding: 0;" class="ri-printer-fill"></i>
              </b-button>
          </b-col>
        </b-row>
        <b-row>
            <b-col lg="12" sm="12">
                <iq-card>
                  <template v-slot:body>
                      <b-overlay :show="unitLoad">
                        <b-row>
                            <b-col lg="4" sm="4">
                                <span class="font-weight-bold">{{ $t('hospital_configuration.hospital_name')}}</span>
                                {{ socialServiceDelivery.hospital_id }}
                            </b-col>
                            <b-col lg="4" sm="4">
                                <span class="font-weight-bold">{{ $t('hospital_information.form_no')}}</span>
                                {{ $n(socialServiceDelivery.form_no, { useGrouping: false }) }}
                            </b-col>
                        </b-row>
                        <b-row>
                          <b-col lg="4" sm="4">
                                  <span class="font-weight-bold">{{ $t('social_service.reg')}}</span>
                                  {{ $n(socialServiceDelivery.registration_no, { useGrouping: false }) }}
                          </b-col>
                        </b-row>
                         <b-row>
                        <b-col lg="4" sm="4">
                            <span class="font-weight-bold">{{ $t('hospital_information.patient_name_en')}}</span>
                            {{ socialServiceDelivery.patient.patient_name }}
                        </b-col>
                        <b-col lg="4" sm="4">
                            <span class="font-weight-bold">{{ $t('hospital_information.patient_name_bn')}}</span>
                            {{ socialServiceDelivery.patient.patient_name_bn }}
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col lg="4" sm="4">
                            <span class="font-weight-bold">{{ $t('hospital_information.age')}}</span>
                            {{ $n(socialServiceDelivery.patient.age) }}
                        </b-col>
                         <b-col lg="4" sm="4">
                            <span class="font-weight-bold">{{ $t('hospital_information.gender')}}</span>
                            {{ socialServiceDelivery.patient.gender_id }}
                        </b-col>
                      </b-row>
                      <template>
                          <div style="font-size:18px; background-color: #005B5B;margin-top:5px">
                              <h5 class="text-white">
                                  {{ $t('social_service.patient_addres') }}
                              </h5>
                          </div>
                          <b-row>
                              <b-col lg="4" sm="4">
                              <span class="font-weight-bold">{{$t('educational_management.name_of_division')}}</span>
                                  {{ socialServiceDelivery.patient.division_id }}
                              </b-col>
                              <b-col lg="4" sm="4">
                                  <span class="font-weight-bold">{{$t('educational_management.name_of_district')}}</span>
                                  {{ socialServiceDelivery.patient.district_id }}
                              </b-col>
                          </b-row>
                           <b-row>
                              <b-col lg="4" sm="4">
                              <span class="font-weight-bold">{{$t('educational_management.name_of_upazilla')}}</span>
                                  {{ socialServiceDelivery.patient.upazilla_id }}
                              </b-col>
                           </b-row>
                          <b-row>
                              <b-col lg="4" sm="4">
                              <span class="font-weight-bold">{{$t('educational_management.address_details')}}</span>
                                   {{ i18 ? socialServiceDelivery.patient.address_bn : socialServiceDelivery.patient.address }}
                                  <!-- {{ socialServiceDelivery.patient.address }} -->
                              </b-col>
                          </b-row>
                        </template>
                        <br><br>
                        <hr>
                        <div style="font-size:18px; background-color: #005B5B;margin-top:5px">
                              <h5 class="text-white">
                                  {{ $t('social_service.other_information') }}
                              </h5>
                        </div>
                        <b-row>
                            <b-col lg="12" sm="12">
                            <b-overlay :show="unitLoad">
                              <div class="table-responsive">
                                <table class="table table-bordered">
                                    <tr class="bg-light">
                                        <th width="5%">{{$t('globalTrans.sl_no')}}</th>
                                        <th width="25%">{{$t('social_service.social_service_cat')}}</th>
                                        <th width="10%">{{$t('social_service.service_date')}}</th>
                                        <th width="10%">{{$t('social_service.service_desc')}}</th>
                                        <!-- <th>{{$t('social_service.service_desc_bn')}}</th> -->
                                        <!-- <th>{{$t('social_service.service_cost_amount')}}</th>
                                        <th>{{$t('social_service.service_cost_desc_en')}}</th>
                                        <th>{{$t('social_service.service_cost_desc_bn')}}</th>
                                        <th>{{$t('social_service.service_odc_name_en')}}</th>
                                        <th>{{$t('social_service.service_odc_name_bn')}}</th> -->
                                        <th width="20%">{{$t('social_service.coment')}}</th>
                                        <!-- <th>{{$t('social_service.coment_bn')}}</th> -->
                                        <!-- <th>{{$t('social_service.receipt')}}</th>
                                        <th>{{$t('globalTrans.attachment')}}</th> -->
                                        <th width="30%">{{$t('globalTrans.description')}}</th>
                                    </tr>
                                    <tbody>
                                        <tr v-for="(check, index) in socialServiceDelivery.other_info" :key="index">
                                            <td>{{ $n(index + 1) }}</td>
                                            <td>{{ getSocialServiceCategory(check.service_category) }}</td>
                                            <td>{{ check.service_date | dateFormat }}</td>
                                            <td>{{ $i18n.locale === 'bn' ? check.description_bn : check.description }}</td>
                                            <!-- <td>{{ check.description_bn }}</td> -->
                                            <!-- <td>{{ $n(check.cost_amount) }}</td>
                                            <td>{{ check.cost_detail }}</td>
                                            <td>{{ check.cost_detail_bn }}</td>
                                            <td>{{ check.officer_name }}</td>
                                            <td>{{ check.officer_name_bn }}</td> -->
                                            <!-- <td>{{ check.comments }}</td> -->
                                            <td>{{ $i18n.locale === 'bn' ? check.comments_bn : check.comments }}</td>
                                            <!-- <td>{{ check.comments_bn }}</td> -->
                                            <!-- <td>
                                                <a v-if="check.attachment !== null" :href="hospitalServiceBaseUrl + 'download-attachment?file=/' + check.attachment" class="btn btn-success"><i class="fa fa-cloud" aria-hidden="true"></i> {{ $t('globalTrans.attachment') }}</a>
                                            </td>
                                            <td>
                                                <a v-if="check.attachment1 !== null" :href="hospitalServiceBaseUrl + 'download-attachment?file=/' + check.attachment1" class="btn btn-success"><i class="fa fa-cloud" aria-hidden="true"></i> {{ $t('globalTrans.attachment') }}</a>
                                            </td> -->
                                            <td>
                                            <div v-html="JSON.parse(check.service_description)"></div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                              </div>
                            </b-overlay>
                          </b-col>
                        </b-row>
                      </b-overlay>
                  </template>
                </iq-card>
            </b-col>
        </b-row>
        <b-modal id="modal-4" size="xl" :title="formTitle"  :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
          <FormV :id="editItemId" :key="editItemId"/>
        </b-modal>
  </b-container>
</template>
<script>
import { core } from '@/config/pluginInit'
import RestApi, { hospitalServiceBaseUrl } from '@/config/api_config'
import { socialServiceDetailsApi } from '../../../api/routes'
import flatpickr from 'flatpickr'
import ExportPdf from './export-pdf-details'
import FormV from './FormV'
export default {
  components: {
    FormV
  },
  created () {
    if (this.$route.query.id) {
      this.getsocialServiceDeliveryData()
    }
  },
  mounted () {
    core.index()
    flatpickr('#registration_date', {})
    flatpickr('#deposit_date', {})
    flatpickr('#expire_date', {})
    flatpickr('#licence_issue_date', {})
    flatpickr('#licence_expire_date', {})
  },
  data () {
    return {
      test: 0,
      saveBtnName: this.id ? this.$t('globalTrans.update') : this.$t('globalTrans.save'),
      perShowData: 0,
      showData: 0,
      socialServiceDelivery: {
        hospital_id: '0',
        patient_type: '0',
        form_no: '',
        registration_no: '',
        pre_pauroshoba_id: 0,
        per_pauroshoba_id: 0,
        per_corporation_id: 0,
        pre_ward_id: 0,
        per_ward_id: 0,
        id: '',
        org_id: '',
        patient: {
          patient_name: '',
          patient_name_bn: '',
          division_id: 0,
          district_id: 0,
          upazilla_id: 0,
          address: '',
          age: '',
          address_bn: '',
          gender_id: '0'
        },
        service_category: '0',
        registration_date: '',
        service_name: '0',
        union_id: 0,
        area_id: 0,
        per_area_id: 0,
        pre_corporation_id: 0,
        other_info: []
      },
      hospitalServiceBaseUrl: hospitalServiceBaseUrl,
      pay_order_attachment: [],
      photo: [],
      districtList: [],
      upazilaList: [],
      unionList: [],
      districtPerList: [],
      upazilaPerList: [],
      unionPerList: [],
      officeList: [],
      cityCorporationList: [],
      pauroshobaList: [],
      wardList: [],
      unitLoad: false,
      areaTypeList: [
        { value: 1, text: this.$t('educational_management.city_corporation') },
        { value: 2, text: this.$t('educational_management.pourosoba') },
        { value: 3, text: this.$t('educational_management.name_of_union') }
      ],
        dealerCategory: [
        { text: (this.$i18n.locale === 'bn') ? 'সার' : 'Fertilizer', value: 2 }
    ]
    }
  },
  computed: {
    socialServiceCategoryList: function () {
      const objectData = this.$store.state.HospitalDisabilityService.commonObj.socialServiceCategoryList
       return objectData.map((obj, key) => {
            if (this.$i18n.locale === 'bn') {
                return { value: obj.value, text: obj.text_bn }
            } else {
                return { value: obj.value, text: obj.text_en }
            }
        })
    },
    i18 () {
      return (this.$i18n.locale === 'bn') ? 1 : 0
    },
    socialServiceNameList: function () {
      const objectData = this.$store.state.HospitalDisabilityService.commonObj.socialServiceNameList
       return objectData.map((obj, key) => {
            if (this.$i18n.locale === 'bn') {
                return { value: obj.value, text: obj.text_bn }
            } else {
                return { value: obj.value, text: obj.text_en }
            }
        })
    },
    orgList: function () {
      return this.$store.state.commonObj.organizationProfileList.filter(item => item.status === 0)
    },
    divisionPreList: function () {
      return this.$store.state.commonObj.divisionList.filter(item => item.status === 0)
    },
    divisionPerList: function () {
      return this.$store.state.commonObj.divisionList.filter(item => item.status === 0)
    },
    yearOfRegistration: function () {
      const fiscalyear = this.$store.state.commonObj.fiscalYearList.filter(item => item.status === 0)
      return fiscalyear.map(item => {
        if (this.$i18n.locale === 'bn') {
            return { value: item.value, text: item.text_bn }
        } else {
            return { value: item.value, text: item.text_en }
        }
      })
    }
  },
  methods: {
     getPatientType (id) {
        const patientType = this.$store.state.HospitalDisabilityService.commonObj.patientTypeList.find(item => item.value === parseInt(id))
        if (patientType) {
          if (this.$i18n.locale === 'bn') {
              return patientType.text_bn
          } else {
              return patientType.text_en
          }
        } else {
          return ''
        }
    },
    getSocialServiceCategory (id) {
      const objectData = this.$store.state.HospitalDisabilityService.commonObj.socialServiceCategoryList.find(item => item.value === id)
      if (objectData) {
        if (this.$i18n.locale === 'bn') {
            return objectData.text_bn
        } else {
            return objectData.text_en
        }
      } else {
        return ''
      }
    },
    getlocation (areaID) {
        if (areaID === 1) {
            this.showData = 1
        }
        if (areaID === 2) {
            this.showData = 2
        }
        if (areaID === 3) {
            this.showData = 3
        }
        return true
    },
    getPerlocation (areaID) {
        if (areaID === 1) {
            this.perShowData = 1
        }
        if (areaID === 2) {
            this.perShowData = 2
        }
        if (areaID === 3) {
            this.perShowData = 3
        }
        return true
    },
    getOfficeList (orgId = null) {
        const officeList = this.$store.state.commonObj.officeList.filter(item => item.status === 0 && item.office_type_id === 72)
        if (orgId) {
            return officeList.filter(office => office.org_id === orgId).map(obj => {
                if (this.$i18n.locale === 'bn') {
                    return { value: obj.value, text: obj.text_bn }
                } else {
                    return { value: obj.value, text: obj.text }
                }
            })
        }
        return officeList
    },
    onOrderLogoChange (e) {
      this.pay_order_attachment = e.target.files[0]
    },
    onPhotoLogoChange (e) {
      this.photo = e.target.files[0]
    },
    async getsocialServiceDeliveryData () {
      this.unitload = true
      const result = await RestApi.getData(hospitalServiceBaseUrl, `${socialServiceDetailsApi}/${this.$route.query.id}`)
       if (result.success) {
        this.socialServiceDelivery = result.data
        // this.socialServiceDelivery.form_no = result.data[0].form_no
        // this.socialServiceDelivery.patient_name = result.data[0].patient.patient_name
        // this.socialServiceDelivery.patient_name_bn = result.data[0].patient.patient_name_bn
        // this.socialServiceDelivery.age = result.data[0].patient.age
        const gender = this.$store.state.commonObj.genderList.find(item => item.value === this.socialServiceDelivery.patient.gender_id)
        this.socialServiceDelivery.patient.gender_id = this.$i18n.locale === 'en' ? gender.text_en : gender.text_bn
        const hospitalList = this.$store.state.HospitalDisabilityService.commonObj.hospitalInfoList.find(item => item.value === this.socialServiceDelivery.hospital_id)
        this.socialServiceDelivery.hospital_id = this.$i18n.locale === 'en' ? hospitalList.text_en : hospitalList.text_bn
        const divisionList = this.$store.state.commonObj.divisionList.find(item => item.value === this.socialServiceDelivery.patient.division_id)
        this.socialServiceDelivery.patient.division_id = this.$i18n.locale === 'en' ? divisionList.text_en : divisionList.text_bn
        const districtList = this.$store.state.commonObj.districtList.find(item => item.value === this.socialServiceDelivery.patient.district_id)
        this.socialServiceDelivery.patient.district_id = this.$i18n.locale === 'en' ? divisionList.text_en : districtList.text_bn
        const upazilaList = this.$store.state.commonObj.upazilaList.find(item => item.value === this.socialServiceDelivery.patient.upazilla_id)
        this.socialServiceDelivery.patient.upazilla_id = this.$i18n.locale === 'en' ? upazilaList.text_en : upazilaList.text_bn
        // this.socialServiceDelivery.address = result.data[0].patient.address
        // this.socialServiceDelivery.address_bn = result.data[0].patient.address_bn
        // ths.socialServiceDelivery.other_info = result.data
       }
      this.unitload = false
    },
    getGender () {
      const gender = this.$store.state.commonObj.genderList.find(item => item.value === this.socialServiceDelivery.patient.gender_id)
      return this.$i18n.locale === 'en' ? gender.text_en : gender.text_bn
    },
    getDivision (id) {
      const divisionList = this.$store.state.commonObj.divisionList.find(item => item.value === id)
      return this.$i18n.locale === 'en' ? divisionList.text_en : divisionList.text_bn
    },
    getDistrict (id) {
      const districtList = this.$store.state.commonObj.divisionList.find(item => item.value === id)
      return this.$i18n.locale === 'en' ? districtList.text_en : districtList.text_bn
    },
    getUpazilla (id) {
      const upazillaList = this.$store.state.commonObj.upazillaList.find(item => item.value === id)
      return this.$i18n.locale === 'en' ? upazillaList.text_en : upazillaList.text_bn
    },
    getPreCityCorporationList (districtId = null) {
      const cityCorporationList = this.$store.state.commonObj.cityCorporationList.filter(item => item.status === 0 && item.district_id === districtId)
      if (districtId) {
        return cityCorporationList.filter(upazila => upazila.district_id === districtId)
      }

      return cityCorporationList
    },
    getPauroshobaList (upazillaId = null) {
      const objectData = this.$store.state.commonObj.pauroshobaList.filter(item => item.upazilla_id === upazillaId)
      if (upazillaId) {
          return objectData.map((obj, key) => {
          if (this.$i18n.locale === 'bn') {
            return { value: obj.value, text: obj.text_bn }
          } else {
            return { value: obj.value, text: obj.text_en }
          }
        })
      }
    },
    getWardListByCityCorportaion (cityCorpId) {
      const objectData = this.$store.state.commonObj.wardList
      const wardObjectList = objectData.filter(item => item.city_corporation_id === cityCorpId && item.status === 0)
      return wardObjectList.map((obj, key) => {
        if (this.$i18n.locale === 'bn') {
          return { value: obj.value, text: obj.text_bn }
        } else {
          return { value: obj.value, text: obj.text }
        }
      })
    },
    getPreUnionList (upazilaId = null) {
      const unionList = this.$store.state.commonObj.unionList
      if (upazilaId) {
        return unionList.filter(union => union.upazilla_id === upazilaId)
      }

      return unionList
    },
    getPerDistrictList (divisionId = null) {
      const districtPerList = this.$store.state.commonObj.districtList

      if (divisionId) {
        return districtPerList.filter(district => district.division_id === divisionId)
      }

      return districtPerList
    },
    getPerUpazilaList (districtId = null) {
      const upazilaPerList = this.$store.state.commonObj.upazilaList

      if (districtId) {
        return upazilaPerList.filter(upazila => upazila.district_id === districtId)
      }

      return upazilaPerList
    },
    getPerUnionList (upazilaId = null) {
      const unionPerList = this.$store.state.commonObj.unionList
      if (upazilaId) {
        return unionPerList.filter(union => union.upazilla_id === upazilaId)
      }

      return unionPerList
    },
    getWardListByPauroshoba (pauroshobaId) {
      const objectData = this.$store.state.commonObj.wardList
      const wardObjectList = objectData.filter(item => item.pauroshoba_id === pauroshobaId && item.status === 0)
        return wardObjectList.map((obj, key) => {
        if (this.$i18n.locale === 'bn') {
          return { value: obj.value, text: obj.text_bn }
        } else {
          return { value: obj.value, text: obj.text }
        }
      })
    },
    async pdfExport () {
        const reportTitle = this.$t('report.bnswc_report')
        const data = JSON.parse(JSON.stringify(this.socialServiceDelivery))
        this.loadingReportData = true
        await ExportPdf.exportPdfDetails(hospitalServiceBaseUrl, 'configuration/report-heading/detail', 3, reportTitle, data, this)
        this.loadingReportData = false
    }
  }
}
</script>
